import { t } from '@lingui/macro';

export const reportsGeneratedMsg = (): string => t`Reports are generated on the 2nd of each month.`;
